<script>
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Orders",
        meta: [{ name: "description", content: appConfig.description }],
    },
    props: {
        customerid :{
            type : Number,
        }
    },
    data(){
        return {
            customer_check_info:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
        };  
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY')
            }
        },

        get_customer_check_by_id(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/checklist/'+this.customerid)
        .then(response => {
            if (response) {
                this.loadingRoles=false;
                this.customer_check_info = response.data;
                console.log("CHECK INFO",this.customer_check_info);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    }, 
    },

    components: {
        DataTable,
    },

    mounted() {
        this.get_customer_check_by_id();     
    },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <div class="card card-height-100">
    <div class="card-body p-0">
      <div>
        <div v-if='loadingRoles'>
              <div class="spinner-border text-success" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
          </div>
          <div v-else>
            <div class="table-responsive">
                <DataTable :options="{lengthChange: false}" class="table table-striped table-nowrap mb-0"> 
                    <thead class="table-secondary">
                        <tr>
                            <th>#.</th>
                            <th scope="col">Program</th>           
                            <th scope="col">Credit Check</th>           
                            <th scope="col">Credit Check Date</th>           
                            <th scope="col">Active Contract</th>                                                                
                            <th scope="col">Black List</th>                                                                
                            <th scope="col">KYC Status</th>
                            <th scope="col">Payment Check</th>
                            <th scope="col">Payment Check Date</th>
                            <th scope="col">Order Number</th>
                            <th scope="col">Contract Number</th>
                            <th scope="col">Created On</th>
                        </tr>
                    </thead>
                    <tbody>                                
                        <tr v-for="(item, index) in customer_check_info" :key="index" class="content">
                            <td><router-link :to="'/customer/customer-check-details/'+item.id" class="fw-medium link-secondary">{{ index+1 }}</router-link></td>

                            <td>{{ item.program_name }}</td>   

                            <td v-if="item.credit_check == 1"><span class="badge bg-success">PASSED</span></td>
                            <td v-else-if="item.credit_check == 2"><span class="badge bg-danger">FAILED</span></td>
                            <td v-else>---</td>

                            <td>{{ format_date(item.credit_check_date) ??  format_date(item.age_check_date) }}</td>

                            <td v-if="item.active_customer_check == 1"><span class="badge bg-success">PASSED</span></td>
                            <td v-else-if="item.active_customer_check == 2"><span class="badge bg-danger">FAILED</span></td>
                            <td v-else>---</td>

                            <td v-if="item.internal_blacklist_check == 1"><span class="badge bg-success">PASSED</span></td>
                            <td v-else-if="item.internal_blacklist_check == 2"><span class="badge bg-danger">FAILED</span></td>
                            <td v-else>---</td>

                            <td v-if="item.kyc_check == 1"><span class="badge bg-success">PASSED</span></td>
                            <td v-else-if="item.kyc_check == 2"><span class="badge bg-danger">FAILED</span></td>
                            <td v-else>---</td>

                            <td v-if="item.payment_check == 1"><span class="badge bg-success">PASSED</span></td>
                            <td v-else-if="item.payment_check == 2"><span class="badge bg-danger">FAILED</span></td>
                            <td v-else>---</td>

                            <td>{{ format_date(item.payment_check_date) }}</td>

                            <td>{{ item.orderId }}</td>

                            <td>{{ item.contract_number }}</td>

                            <td>{{ format_date(item.created_at) }}</td>                                   
                        </tr>
                    </tbody>
                </DataTable>
            </div>
        </div>
      </div>
    </div>
  </div>



</template>
